<template>
  <div class="photo-cell col-12 col-md-6 col-lg-6" :style="{height:photoCellHeight +'px'}" ref="photoCell">
    <div class="photo-cell-inner h-100 p-1" :class="{ favorite: input.isBuyTarget }">
      <div class="row no-gutters h-100">
        <div class="col text-center h-100">
          <div class="photo-image contain" v-lazy:background-image="smallThumbnailUrl" @click="showPhotoImageModal" style="background-position: bottom;"></div>
        </div>
        <div class="col-auto text-center h-100" style="padding-left:1px;">
          <div class="d-flex flex-column h-100 cart-photo-operation">
            <div class="photo-no text-center mb-auto">{{photo.photo_no}}</div>
            <div>
              <div class="price-info">
                <trans-text i18nKey="ui['91'][3]"/>
              </div>

              <div class="text-left">
                <span class="size-info d-inline-block px-1">{{photoSizeMark}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {dd,store,app} from 'systems/imports'

  export default {
    name:"",
    props:["cartPhoto","cart"],

    components: {
    },
    data () {
      return {
        input:{
          isBuyTarget:false,
        },
        photoCellHeight:null,
        photoImageWrapHeight:null
      }
    },
    watch:{
      "$root.lastAtAdjustLayout"(){
        this.$nextTick()
          .then(()=>{
            this._adjustPhotoCellHeight()
            this.photoImageWrapHeight = 0
            return this.$nextTick()
          }).then(()=>{
          this._adjustphotoImageWrapHeight()
        })
      },
      "cartPhoto"(){
        if(!this.cartPhoto){return false }
        this.input.isBuyTarget = this.cartPhoto.is_purchase_target
      },
      "input.isBuyTarget"(){
        this.$emit("changeCartPhotoPurchaseTarget",this.cartPhoto,this.input.isBuyTarget)
      },
    },
    mounted(){
      this.$nextTick(()=>{
        this._adjustPhotoCellHeight()
        this.$nextTick(()=>{
          this._adjustphotoImageWrapHeight()
        })
      })
      if(this.cartPhoto){
        this.input.isBuyTarget = this.cartPhoto.is_purchase_target
      }

    },
    computed:{
      photo(){
        return this.cartPhoto.photo || {}
      },
      photoSizeMark(){
        let cartPhoto = this.cartPhoto
        if(!cartPhoto){ return "M" }
        if(!cartPhoto.photo_sizes){ return "M" }
        let photoSize = app.make("_").first(cartPhoto.photo_sizes)
        if(!photoSize){
          return "M"
        }
        switch(Number(photoSize.id)){
          case 1:
            return "M"
          case 2:
            return "L"
        }
      },
      isFavorited(){
        return !app.make("_").isEmpty(this.photo.cart_photos);
      },
      smallThumbnailUrl(){
        let photo = this.photo
        if(!photo){ return null }
        let photoThumbnail = app.make("_").find(photo.photo_thumbnails,(photo_thumbnail)=>{
          return (String(photo_thumbnail.type_code) === "1")
        })
        return photoThumbnail.image_url + '?token='+store.get("token")
      },
    },
    methods:{
      toggleCartPhotoSizePopoverForm(){
          this.$emit("toggleCartPhotoSizePopoverForm",this.cartPhoto)
      },
      //
      _adjustPhotoCellHeight(){
        this.photoCellHeight = $(this.$refs.photoCell).width() / 2
      },
      _adjustphotoImageWrapHeight(){
        this.photoImageWrapHeight = $(this.$refs.photoImageWrap).height()
      },

      //
      showPhotoImageModal(){
        this.$emit("showPhotoImageModal",this.photo)
      },
      removeCartPhoto(){
        this.$emit("removeCartPhoto",this.cartPhoto)
      }
    }
  }
</script>


<style lang="scss" scoped>
  .custom-control-indicator{
    top:0;
    border:2px solid #a8a5a3;
    background-color: #fff;
  }
  .purchase-target-check{
    position: absolute;
    right: 25px;
    top: 0;
    z-index: 100;
    span,input{
      width: 1.5rem;
      height:1.5rem;
    }
  }

  .purchased-label{
    font-size: 0.6rem;
    color: #82ba1d;
    border: #82ba1d solid 1px;
    vertical-align: bottom;
    padding: 0 1px;
  }

  .photo-cell {
    margin-bottom: 2px;

    .photo-cell-inner {
      //box-shadow:5px 5px 8px 3px #ccc inset;
      background-color: #fff;
      border: 2px solid #a8a5a3;
      border-radius: .5rem;
      &.favorite {
        border: 2px solid #ec5c45;
      }
      .photo-no {
        font-size: 0.8rem;
      }

      .cart-photo-operation{

        @mixin cart-photo-operation-btn-style {
          font-size:10px;
          padding:2px;
          //          padding:0;
          margin:0;
        }
        .favorite-operation{
          @include cart-photo-operation-btn-style;
          vertical-align: bottom;
          width:100%;

        }
        .size-info{
          @include cart-photo-operation-btn-style;
          color:#f79a1d;
          font-weight: bold;
          border: 1px #f79a1d solid;
          line-height: 1.25;
          vertical-align: bottom;
        }
        .size-operation{
          @include cart-photo-operation-btn-style;
          vertical-align: top;
          width:100%;

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// GroupHorizonPhoto.vue?2addb0dc